// extracted by mini-css-extract-plugin
export default {"ProductsModal":"styles_ProductsModal__NsPHF","product":"styles_product__+ISGW","product__link":"styles_product__link__yDSGt","product__image":"styles_product__image__r2XaX"};